import * as React from "react";

import { CheckIcon, CopyIcon } from "lucide-react";
import { cn } from "lib/utils";
import { Button } from "js/components/ui/button";
import { useClipboard } from "hooks/useClipboard";
import { toast } from "utils/toast";

function CopyButton({
  value,
  className,
  ...props
}: { value: string } & Omit<
  React.ComponentProps<typeof Button>,
  "onClick" | "children"
>) {
  const { isCopied, copy } = useClipboard({
    timeout: 2000,
    onSuccess: () => toast.success("Copiado al portapapeles"),
  });

  return (
    <Button
      data-slot="copy-button"
      variant="ghost"
      size="icon"
      className={cn("size-7 shrink-0", className)}
      aria-label="Copiar al portapapeles"
      onClick={() => copy(value)}
      {...props}
    >
      {isCopied ? (
        <CheckIcon className="size-3.5 text-emerald-500" />
      ) : (
        <CopyIcon className="size-3.5 text-muted-foreground" />
      )}
    </Button>
  );
}

export { CopyButton };
